import { motion } from "framer-motion";
import Button from "../Button";
import styles from "./StepError.module.css";

interface StepErrorProps {
  message: string;
  onRetry?: () => void;
  showRetry?: boolean;
}

const StepError: React.FC<StepErrorProps> = ({ message, onRetry, showRetry = true }) => {
  return (
    <motion.div
      className={styles.error}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <p>{message}</p>
      {showRetry && onRetry && <Button onClick={onRetry}>Попробовать снова</Button>}
    </motion.div>
  );
};

export default StepError;
